/**
 * Single source of truth for rendering money in the app. Always renders the currency
 * code as a suffix so the user is never confused about CAD vs USD on a $X amount.
 *
 *   formatCurrency(5277, 'USD') → "$52.77 USD"
 *   formatCurrency(5277, 'CAD') → "$52.77 CAD"
 *   formatCurrency(0,    'USD') → "$0.00 USD"
 *   formatCurrency(null, 'CAD') → "$0.00 CAD"
 *
 * Both currencies share the "$" prefix (they're both dollar units). The suffix is the
 * disambiguator — no US$/CA$ prefix variant because they read poorly on small fonts.
 */
export default function formatCurrency(cents, currency = 'CAD') {
  const c = typeof cents === 'number' ? cents : 0;
  const cc = (currency || 'CAD').toUpperCase();
  const sign = c < 0 ? '-' : '';
  const abs = Math.abs(c) / 100;
  return `${sign}$${abs.toFixed(2)} ${cc}`;
}

/** Display the per-period suffix for a club's pricing card. */
export function billingPeriodLabel(mode, billingPeriod, termDays) {
  if (mode === 'subscription') {
    return billingPeriod === 'annual' ? ' per year' : ' per month';
  }
  if (mode === 'one_time') {
    if (!termDays) return ' · lifetime';
    if (termDays === 365) return ' · for the year';
    if (termDays === 30) return ' · for the month';
    return ` · for ${termDays} days`;
  }
  return '';
}
